import { render, staticRenderFns } from "./ChangedFiles.vue?vue&type=template&id=639fe46a&"
import script from "./ChangedFiles.vue?vue&type=script&lang=js&"
export * from "./ChangedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports